// The form a vendor page slug takes (#425): lowercase ASCII letters and digits
// in runs joined by single hyphens, at most 128 characters. The API's own rule
// (VendorSlugHelper.Pattern and DomainConstraint.Vendor.Slug.MaxLength),
// mirrored, so a slug the API would refuse with a 400 is never sent: the
// vendor page shows "not found" for it without a read, and a promotion falls
// back to the vendor's grid rather than link to that page.
const VENDOR_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const VENDOR_SLUG_MAX_LENGTH = 128;

export const isVendorSlug = (value: string): boolean =>
    value.length <= VENDOR_SLUG_MAX_LENGTH && VENDOR_SLUG_PATTERN.test(value);
